import { kustomerAuthService } from '_services';
import {oauthConstants, alertMessages, toastMessage} from '_constants';
import {SnackBar} from "../components/common";
import {Toast} from "../components/v3/common/Toast";


/**
 * This method handles verification of the user's credentials
 * @param params
 * @returns {Function}
 */

export const kustomerAuthActions = {
    verifyKey
};

function verifyKey(params) {
    function request() {
        return {type: oauthConstants.KUSTOMER_VERIFY_KEY_REQUEST};
    }

    function success() {
        return {type: oauthConstants.KUSTOMER_VERIFY_KEY_SUCCESS}
    }

    function failure() {
        return {type: oauthConstants.KUSTOMER_VERIFY_KEY_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        kustomerAuthService.verifyApiKey(params)
            .then(
                (res) => {
                    dispatch(success(res));

                    if (res === true){
                        dispatch(createAccount(params))
                    }

                },
                (error) => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.KUSTOMER_VERIFY_KEY_FAILURE);
                },
            );
    };
}

function createAccount (params){
    function request() {
        return {type: oauthConstants.KUSTOMER_CREATE_ACCOUNT_REQUEST};
    }

    function success(payload) {
        return {type: oauthConstants.KUSTOMER_CREATE_ACCOUNT_SUCCESS,payload}
    }

    function failure() {
        return {type: oauthConstants.KUSTOMER_CREATE_ACCOUNT_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        kustomerAuthService.createAccount(params)
            .then(
    (res) => {

                    dispatch(success(res));
                    kustomerAuthService.savePayload(res);
                    const {successMessage, options} = toastMessage.connectChannel;
                    Toast.showMessage(successMessage, options);
                },
                (error) => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.KUSTOMER_CREATE_ACCOUNT_FAILURE);
                },
            );
    };
}
